import { default as DreamBuilder } from './ContentDreamBuilder/ContentDreamBuilder.container';
import { default as FourthWall } from './ContentFourthWall/ContentFourthWall.container';
import { default as Realtime } from './ContentRealtime/ContentRealtime.container';

export const content = {
  DreamBuilder,
  FourthWall,
  Realtime,
};
